// import courses
import ent from "../assets/data/ent.json";
import eng from "../assets/data/english.json";
import _ from "lodash";
import { getEnvironment } from "./env.util";
let engCoursesJSON =
  getEnvironment() === "staging" ? eng.data.staging : eng.data.production;
let entCoursesJSON =
  getEnvironment() === "staging" ? ent.data.staging : ent.data.production;
export const groupedCourses = data => {
  return _.groupBy(data, "status");
};

export const engCourses = data => {
  const engJSON = engCoursesJSON.courses.map(course => {
    if (Object.keys(data.courses).includes(course.id)) {
      course.status = data.courses[course.id].enrollment_state;
      course.url = data.courses[course.id].url;
    } else {
      course.status = "available";
      course.url = "";
    }
    return course;
  });
  return engJSON;
};
export const entCourses = data => {
  const entJSON = entCoursesJSON.courses.map(course => {
    if (Object.keys(data.courses).includes(course.id)) {
      course.status = data.courses[course.id].enrollment_state;
      course.url = data.courses[course.id].url;
    } else {
      course.status = "available";
      course.url = "";
    }
    return course;
  });
  return entJSON;
};

export default { entCourses, engCourses, groupedCourses };
